import BaseViz from './BaseViz'
import LineChartChart from '../charts/LineChartChart'
import LineChartDataController from '../viz_behaviors/LineChartDataController'
export default class LineChartViz extends BaseViz {
  static chartClass = LineChartChart
  static defaultConfig = {
    mode: {
      type: String,
      default: 'lines',
      options: ['lines', 'areas'],
    },
    ItemsHelper: {
      colorScale: {
        value: 'categorical',
        options: ['categorical'],
        nonEditable: true,
      },
    },
    AxisHelper: {
      y: {
        trimThreshold: {
          nonEditable: true,
        },
      },
      x: {
        trimThreshold: {
          nonEditable: true,
        },
        showTickValues: {
          nonEditable: false,
        },
        scale: {
          nonEditable: true,
        },
        domain: {
          nonEditable: true,
        },
      },
      zoomAxes: ['x'],
    },
    BrushHelper: {
      enabled: {
        default: false,
      },
    },
    TooltipBehavior: {
      getHtml: function (d) {
        return `
        <div class="tip-value important">${this.formatTooltipValue(d.value, 'y')}</div>
        <div class="tip-id">
          <span class="icon" style="display: inline-block; width: 9px; height: 9px; border-radius: 50%; background: ${this.color(
            { id: d.parentId }
          )}; margin-right: 3px"></span>
          ${d.parentId}
        </div>
        <div class="secondary">${this.formatTooltipValue(d.id, 'x')}</div>
      `
      },
    },
    LegendBehavior: {
      icon: 'line',
    },
  }
  static dataControllerClass = LineChartDataController
}
